import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'
import moment from 'moment'

export const COUPON_TAB_TYPE = {
  freePass: { key: 'freePass', label: 'フリーパス' },
  coupon: { key: 'coupon', label: 'クーポン' }
}

export const COUPON_SELECT_TYPE = {
  notYet: { key: 'notYet', label: '' },
  eatIn: { key: 'eatIn', label: '店舗' },
  gift: { key: 'gift', label: 'このクーポン' }
}

export const SCREEN_TYPE = {
  list: 'list',
  modal: 'modal',
  usedModal: 'usedModal',
  detail: 'detail'
}

const STORED_COUPONS_KEY = {
  selectedCoupons: 'selectedCoupons',
  usedCoupons: 'usedCoupons'
}

const STORED_COUPONS_MODIFIER = {
  add: 'add',
  remove: 'remove',
  clear: 'clear'
}

const COUPON_SORT_BY = {
  expire: { key: 'expire', label: '有効期限順' },
  prize: { key: 'prize', label: 'スタンプ特典を上に' },
  lounge: { key: 'lounge', label: 'ラウンジクーポンを上に' },
  timeLimited: { key: 'timeLimited', label: '期間限定を上に' },
  infinite: { key: 'infinite', label: '何度でもご利用可能を上に' },
  onlyForYou: { key: 'onlyForYou', label: 'あなただけを上に' }
}

const FREE_PASS_SORT_BY = {
  expire: { key: 'expire', label: '有効期限順' },
  lounge: { key: 'lounge', label: 'ラウンジフリーパスを上に' }
}

export const calcIsCloseExpireAt = (expireAt) => {
  const to = moment(expireAt)
  const from = moment()
  const diff = to.diff(from, 'days')
  return diff <= 7
}

const isPrizeCoupon = (coupon) => {
  // 特典 ( type = 1 ) かつ 通常特典 ( purpose = 0 ) をフィルタ
  return coupon.type === '1' && coupon.data.purpose === '0'
}

const isLoungeCoupon = (coupon) => {
  // ラウンジクーポンのみ ( target_user_type != 0 ) をフィルタ
  return coupon.data.target_user_type !== '0'
}

const isTimeLimitedCoupon = (coupon) => {
  // 期間限定のみ ( coupon_category = 1 ) をフィルタ
  return coupon.data.coupon_category === '1'
}

const isInfiniteCoupon = (coupon) => {
  // 何度でも利用可能 ( limit = 0 ) かつ 期間限定でなく ( coupon_category != 1 ) かつ あなただけでない ( coupon_category != 3 ) をフィルタ
  return coupon.data.limit === '0' && coupon.data.coupon_category !== '1' && coupon.data.coupon_category !== '3'
}

const isOnlyForYouCoupon = (coupon) => {
  // あなただけ ( coupon_category = 3 ) または 通常特典でない ( purpose != 0 ) をフィルタ
  console.log(coupon.data.purpose)
  return coupon.data.coupon_category === '3' || coupon.data.purpose !== '0'
}

const couponsForDisplay = (state) => {
  const updateBaseCoupons = (targets, bases = null) => {
    targets.sort((a, b) => {
      return moment(a.data.expire_at).unix() - moment(b.data.expire_at).unix()
    })
    return bases ? bases.filter((bc) => {
      return !targets.some(tc =>
        bc.data.coupon_id === tc.data.coupon_id && bc.data.prize_id === tc.data.prize_id
      )
    }) : targets
  }

  let baseCoupons = state.coupons.filter((c) => {
    // モーダル表示中は全てのクーポンを返す
    if (state.showModal) {
      return c
    }

    // リスト表示中は選択中のタブによりクーポン or フリーパスでフィルタ
    // ラウンジのリスト表示ではラウンジクーポンのみ ( target_user_type != 0 ) をフィルタ
    const couponFilter = state.inPremiumLounge ? c.data.prize_type === '0' && isLoungeCoupon(c) : c.data.prize_type === '0'
    const freePassFilter = state.inPremiumLounge ? c.data.prize_type !== '0' && isLoungeCoupon(c) : c.data.prize_type !== '0'
    return state.selectedTab.key === COUPON_TAB_TYPE.coupon.key ? couponFilter : freePassFilter
  })

  const selectedSorter = state.selectedTab.key === COUPON_TAB_TYPE.coupon.key ?
    state.selectedSorter :
    state.selectedSorterForFreePass

  const unavailableCoupons = baseCoupons.filter((uc) => {
    return uc.data.status === '0'
  })
  baseCoupons = updateBaseCoupons(unavailableCoupons, baseCoupons)

  const usingCoupons = (selectedSorter.key === COUPON_SORT_BY.expire.key || selectedSorter.key === FREE_PASS_SORT_BY.expire.key) ?
    baseCoupons.filter((bc) => {
      return bc.data.last_history
    }) : []
  baseCoupons = updateBaseCoupons(usingCoupons, baseCoupons)

  const selectingCoupons = baseCoupons.filter((fc) => {
    return state.selectedCoupons.some(sc =>
      sc.data.coupon_id === fc.data.coupon_id && sc.data.prize_id === fc.data.prize_id
    )
  })
  baseCoupons = updateBaseCoupons(selectingCoupons, baseCoupons)

  const preferredCoupons = baseCoupons.filter((c) => {
    if (state.inPremiumLounge) {
      // プレミアムラウンジから参照する場合は必ずラウンジクーポンを優先クーポンとする
      // ラウンジクーポンのみ ( target_user_type != 0 ) をフィルタ
      return isLoungeCoupon(c)
    } else if (selectedSorter.key === COUPON_SORT_BY.prize.key) {
      return isPrizeCoupon(c)
    } else if (
      selectedSorter.key === COUPON_SORT_BY.lounge.key ||
      selectedSorter.key === FREE_PASS_SORT_BY.lounge.key
    ) {
      return isLoungeCoupon(c)
    } else if (selectedSorter.key === COUPON_SORT_BY.timeLimited.key) {
      return isTimeLimitedCoupon(c)
    } else if (selectedSorter.key === COUPON_SORT_BY.infinite.key) {
      return isInfiniteCoupon(c)
    } else if (selectedSorter.key === COUPON_SORT_BY.onlyForYou.key) {
      return isOnlyForYouCoupon(c)
    } else {
      // フィルタなし
      return c
    }
  })

  baseCoupons = updateBaseCoupons(preferredCoupons, baseCoupons)
  baseCoupons = updateBaseCoupons(baseCoupons)

  // const unavailableCouponsForDisplay = state.showModal ? [] : unavailableCoupons
  // const coupons = [...selectingCoupons, ...usingCoupons, ...preferredCoupons, ...baseCoupons, ...unavailableCouponsForDisplay]
  const coupons = [...selectingCoupons, ...usingCoupons, ...preferredCoupons, ...baseCoupons]
  const preferredCouponsDoesNotExist = coupons.length > 0 && preferredCoupons.length < 1

  return { coupons, preferredCouponsDoesNotExist }
}

const couponsForDisplayFilteredByScreenType = (state, screenType) => {
  return state.couponsForDisplay.filter((c) => {
    if (state.selectedType.key === COUPON_SELECT_TYPE.notYet.key || screenType === SCREEN_TYPE.list) {
      // 選択タイプ未設定 or リスト表示時は全てのクーポンを返す
      return c
    } else if (state.selectedType.key === COUPON_SELECT_TYPE.eatIn.key) {
      // モーダル表示時かつ選択タイプがイートインの場合は、ギフトクーポンではないかつイートイン利用可能なクーポンを返す
      return c.data.type !== '1' && c.data.not_eat_in === '0'
    } else if (state.selectedType.key === COUPON_SELECT_TYPE.gift.key) {
      // モーダル表示時かつ選択タイプがギフトの場合は、ギフトクーポンを返す
      return c.data.type === '1'
    }
  })
}

export const CouponWithCart = {
  namespaced: true,
  state: {
    tabs: [],
    selectedTab: COUPON_TAB_TYPE.coupon,
    coupons: [],
    couponsForDisplay: [],
    sorters: [],
    selectedSorter: COUPON_SORT_BY.expire,
    selectedSorterForFreePass: FREE_PASS_SORT_BY.expire,
    selectedType: COUPON_SELECT_TYPE.notYet,
    selectedCoupons: [],
    usedCoupons: [],
    inPremiumLounge: false,
    showModal: false,
    showUsedModal: false,
    preferredCouponsDoesNotExist: false
  },
  getters: {
    tabs: (state) => {
      return state.tabs
    },
    selectedTab: (state) => {
      return state.selectedTab
    },
    couponsForList: (state) => {
      return couponsForDisplayFilteredByScreenType(state, SCREEN_TYPE.list)
    },
    couponsForModal: (state) => {
      return couponsForDisplayFilteredByScreenType(state, SCREEN_TYPE.modal)
    },
    selectedCoupons: (state) => {
      return state.selectedCoupons
    },
    usedCoupons: (state) => {
      return state.usedCoupons
    },
    sorters: (state) => {
      return state.sorters
    },
    selectedSorter: (state) => {
      return state.selectedTab.key === COUPON_TAB_TYPE.coupon.key ?
        state.selectedSorter :
        state.selectedSorterForFreePass
    },
    selectedType: (state) => {
      return state.selectedType
    },
    hasCloseExpireAtCoupon: (state) => {
      const closeExpireAtCouponIndex = state.couponsForDisplay.findIndex((c) => {
        return calcIsCloseExpireAt(c.data.expire_at)
      })
      return closeExpireAtCouponIndex > -1
    },
    couponTabByExpire: (state) => {
      const closeExpireAtCoupon = state.coupons.find((c) => {
        return calcIsCloseExpireAt(c.data.expire_at) && c.data.prize_type === '0'
      })
      const closeExpireAtFreePass = state.coupons.find((c) => {
        return calcIsCloseExpireAt(c.data.expire_at) && c.data.prize_type !== '0'
      })
      const freePass = state.coupons.find((c) => {
        return c.data.prize_type !== '0'
      })
      return closeExpireAtFreePass ?
        COUPON_TAB_TYPE.freePass :
        freePass && !closeExpireAtCoupon ?
          COUPON_TAB_TYPE.freePass :
          COUPON_TAB_TYPE.coupon
    },
    inPremiumLounge: (state) => {
      return state.inPremiumLounge
    },
    showModal: (state) => {
      return state.showModal
    },
    showUsedModal: (state) => {
      return state.showUsedModal
    },
    preferredCouponsDoesNotExist: (state) => {
      return state.preferredCouponsDoesNotExist
    }
  },
  mutations: {
    updateTabs(state, coupons) {
      const entries = Object.entries(COUPON_TAB_TYPE).map((t) => {
        if (t[1].key === COUPON_TAB_TYPE.freePass.key) {
          const freePass = coupons.find((c) => {
            return state.inPremiumLounge ?
              c.data.prize_type !== '0' && c.data.target_user_type !== '0' :
              c.data.prize_type !== '0'
          })
          if (freePass) {
            return t
          }
          return undefined
        }
        return t
      }).filter((t) => {
        return t
      })
      state.tabs = entries.reduce((tab, [key, value]) => {
        tab[key] = value
        return tab
      }, {})
    },
    updateSelectedTab(state, tab) {
      state.selectedTab = tab
    },
    updateCoupons(state, coupons) {
      state.coupons = coupons
    },
    updateCouponsForDisplay(state, needsToast = false) {
      const { coupons, preferredCouponsDoesNotExist } = couponsForDisplay(state)
      state.couponsForDisplay = coupons
      state.preferredCouponsDoesNotExist = needsToast ? preferredCouponsDoesNotExist : false
    },
    updateSorters(state) {
      if (state.selectedTab.key === COUPON_TAB_TYPE.freePass.key) {
        const targetCoupon = state.couponsForDisplay.find((c) => {
          return isLoungeCoupon(c) && c.data.status !== '0'
        })
        if (!targetCoupon) {
          state.sorters = []
          return
        }
      }

      const sorters = state.selectedTab.key === COUPON_TAB_TYPE.coupon.key ? COUPON_SORT_BY : FREE_PASS_SORT_BY
      const entries = Object.entries(sorters).map((s) => {
        const targetCoupon = state.couponsForDisplay.find((c) => {
          if (s[1].key === COUPON_SORT_BY.lounge.key || s[1].key === FREE_PASS_SORT_BY.lounge.key) {
            return isLoungeCoupon(c) && c.data.status !== '0'
          } else if (s[1].key === COUPON_SORT_BY.prize.key) {
            return isPrizeCoupon(c) && c.data.status !== '0'
          } else if (s[1].key === COUPON_SORT_BY.timeLimited.key) {
            return isTimeLimitedCoupon(c) && c.data.status !== '0'
          } else if (s[1].key === COUPON_SORT_BY.infinite.key) {
            return isInfiniteCoupon(c) && c.data.status !== '0'
          } else if (s[1].key === COUPON_SORT_BY.onlyForYou.key) {
            return isOnlyForYouCoupon(c) && c.data.status !== '0'
          }
          return c
        })
        if (targetCoupon) {
          return s
        }
        return undefined
      }).filter((s) => {
        return s
      })

      state.sorters = entries.reduce((sorter, [key, value]) => {
        sorter[key] = value
        return sorter
      }, {})
    },
    updateSelectedSorter(state, sorter) {
      if (state.selectedTab.key === COUPON_TAB_TYPE.coupon.key) {
        state.selectedSorter = sorter
      } else {
        state.selectedSorterForFreePass = sorter
      }
    },
    updateSelectedType(state, selectType) {
      state.selectedType = selectType
    },
    updateStoredCoupons(state, options) {
      if (options.modifier === STORED_COUPONS_MODIFIER.add) {
        state[options.key].push(options.coupon)
      } else if (options.modifier === STORED_COUPONS_MODIFIER.remove) {
        state[options.key] = state.selectedCoupons.filter((c) => {
          return c.data.coupon_id !== options.coupon.data.coupon_id || c.data.prize_id !== options.coupon.data.prize_id
        })
      } else if (options.modifier === STORED_COUPONS_MODIFIER.clear) {
        state[options.key] = []
      }
    },
    updateInPremiumLounge(state, inPremiumLounge) {
      state.inPremiumLounge = inPremiumLounge
    },
    updateShowModal(state, showModal) {
      state.showModal = showModal
    },
    updateShowUsedModal(state, showUsedModal) {
      state.showUsedModal = showUsedModal
    }
  },
  actions: {
    async fetchCoupons({ commit, state }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime

      if (!token) {
        const error = {
          title: `エラー ${ErrorCode.CODE_ERROR_TOKEN}`,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }

      const res = await APIClient.getCouponList(token, accTime, userId)
      if (res && res.data && res.data.data && res.data.data.code === ErrorCode.CODE_SUCCESS) {
        commit('updateCoupons', res.data.data['coupon_data']['coupons'])
        commit('updateTabs', res.data.data['coupon_data']['coupons'])
        commit('updateCouponsForDisplay')
        commit('updateSorters')
      } else {
        const error = {
          title: res && res.data && res.data.data && res.data.data.code ?
            `エラー ${res.data.data.code}` :
            `エラー ${ErrorCode.CODE_ERROR_NETWORK}`,
          message: res && res.data && res.data.data && res.data.data.message ?
            res.data.data.message :
            ErrorMessage.MSG_ERROR_NETWORK
        }
        throw error
      }
    },
    setSelectedTab({ commit, state }, tab) {
      commit('updateSelectedTab', tab)
      commit('updateCouponsForDisplay')
      commit('updateSorters')
    },
    selectSorter({ commit }, sorter) {
      commit('updateSelectedSorter', sorter)
      commit('updateCouponsForDisplay', true)
    },
    setSelectedType({ commit }, type) {
      commit('updateSelectedType', type)
    },
    addToSelectedCoupon({ commit }, coupon) {
      commit('updateStoredCoupons', {
        key: STORED_COUPONS_KEY.selectedCoupons,
        modifier: STORED_COUPONS_MODIFIER.add,
        coupon
      })
    },
    removeFromSelectedCoupon({ commit, state }, coupon) {
      commit('updateStoredCoupons', {
        key: STORED_COUPONS_KEY.selectedCoupons,
        modifier: STORED_COUPONS_MODIFIER.remove,
        coupon
      })

      if (!state.showModal) {
        commit('updateCouponsForDisplay')

        if (state.selectedCoupons.length < 1) {
          commit('updateSelectedType', COUPON_SELECT_TYPE.notYet)
        }
      }
    },
    clearSelectedCoupons({ commit, state }) {
      commit('updateStoredCoupons', {
        key: STORED_COUPONS_KEY.selectedCoupons,
        modifier: STORED_COUPONS_MODIFIER.clear
      })

      if (!state.showModal) {
        commit('updateSelectedType', COUPON_SELECT_TYPE.notYet)
      }
    },
    addToUsedCoupon({ commit }, coupon) {
      commit('updateStoredCoupons', {
        key: STORED_COUPONS_KEY.usedCoupons,
        modifier: STORED_COUPONS_MODIFIER.add,
        coupon
      })
    },
    clearUsedCoupons({ commit }) {
      commit('updateStoredCoupons', {
        key: STORED_COUPONS_KEY.usedCoupons,
        modifier: STORED_COUPONS_MODIFIER.clear
      })
    },
    async useCoupons({ commit, state, dispatch }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      const couponIds = payload.couponIds
      const giftType = payload.giftType
      const giftId = payload.giftId
      const isWebOrder = payload.isWebOrder

      if (!token) {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }

      let res = null
      let success = false
      let giftUrl = null
      // TODO: useMultiCoupons API から weborder_url が返るようになったら動作確認
      let webOrderUrl = null

      if (giftType && giftId) {
        if (giftType === '0') {
          // クーポン利用
          res = await APIClient.postUseCoupon(token, accTime, userId, giftId, false)
        } else if (giftType === '1') {
          // 特典利用
          res = await APIClient.postExchangePrize(token, accTime, userId, giftId, false)
        }

        if (res && res.data && res.data.data && res.data.data.code === ErrorCode.CODE_SUCCESS) {
          success = true
          giftUrl = res.data.data.gift_url
        } else {
          const error = {
            title: res && res.data && res.data.data && res.data.data.code ?
              `エラー ${res.data.data.code}` :
              `エラー ${ErrorCode.CODE_ERROR_NETWORK}`,
            message: res && res.data && res.data.data && res.data.data.message ?
              res.data.data.message :
              ErrorMessage.MSG_ERROR_NETWORK
          }
          // eslint-disable-next-line no-throw-literal
          throw [error]
        }
      } else {
        res = await APIClient.useMultiCoupon(token, accTime, userId, couponIds, isWebOrder)
        const isSuccess = res &&
          res.data && res.data.data &&
          res.data.data.coupon_data &&
          res.data.data.coupon_data.result === 'success'
        if (isSuccess) {
          success = isSuccess
          webOrderUrl = res.data.data.coupon_data.weborder_url
        } else {
          let errors
          if (res && res.data && res.data.data && res.data.data.coupon_data && res.data.data.coupon_data.errors) {
            errors = res.data.data.coupon_data.errors.map((e) => {
              const coupon = state.coupons.find((c) => c.data.coupon_id === e.coupon_id || c.data.prize_id === e.coupon_id)
              const message = `${e.error_msg}${coupon ? ` ( ${coupon.data.caption} )` : ''}`
              return { title: `エラー ${e.error_code}`, message }
            })
          } else {
            errors = [
              { title: `エラー ${ErrorCode.CODE_ERROR_NETWORK}`, message: ErrorMessage.MSG_ERROR_NETWORK }
            ]
          }
          throw errors
        }
      }

      if (success) {
        const lastHistory = moment().format('YYYY/MM/DD HH:mm')

        for (const usedCoupon of state.selectedCoupons) {
          dispatch('addToUsedCoupon', {
            ...usedCoupon,
            data: {
              ...usedCoupon.data,
              last_history: lastHistory,
              last_history_channel: isWebOrder
            }
          })
        }
        dispatch('clearSelectedCoupons')
      }
      return { giftUrl, webOrderUrl }
    },
    setInPremiumLounge({ commit }, inPremiumLounge) {
      commit('updateInPremiumLounge', inPremiumLounge)
      commit('updateCouponsForDisplay')
    },
    setShowModal({ commit }, showModal) {
      commit('updateShowModal', showModal)
      commit('updateCouponsForDisplay')
    },
    setShowUsedModal({ commit }, showUsedModal) {
      commit('updateShowUsedModal', showUsedModal)
    }
  }
}
